import React from "react";

import { useTranslation } from "react-i18next";

import ChannelLogoPosition from "./ChannelLogoPosition";
import ChannelLogoUploader from "./ChannelLogoUploader";
import Block from "../../block/Block";
import Input from "../../form/Input";

import type { JSX } from "react";

interface Props {
  uploadPercentage: number;
  isUploadSuccess: boolean;
  isUploadError: boolean;
}

export default function ChannelSettings({
  uploadPercentage,
  isUploadSuccess,
  isUploadError,
}: Props): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  return (
    <Block title={t("channelSettings")}>
      <Input
        isRequired
        label={t("channelName")}
        name="channelName"
        sublabel={t("channelNameSublabel")}
      />
      <ChannelLogoUploader
        isUploadError={isUploadError}
        isUploadSuccess={isUploadSuccess}
        uploadPercentage={uploadPercentage}
      />
      <ChannelLogoPosition />
    </Block>
  );
}
